import { Injectable, signal } from '@angular/core';
import { Message } from '@models';

const MESSAGE_TIMEOUT = 6;
const DETECTION_MESSAGE_TIMEOUT = 20;

@Injectable({
  providedIn: 'root',
})
export class MessageService {
  messages = signal<Message[]>([]);
  currentMessage = signal<Message>(null);
  debugMessage = signal<string>(null);
  trackingInfo = signal<string>(null);
  addedMessageToHistory = signal(false);
  private detectionMessage: Message;
  private timeoutId: NodeJS.Timeout;
  private timeoutDetection: NodeJS.Timeout;
  private killedDetectionMessage = true;

  showMessage(message: Message) {
    clearTimeout(this.timeoutId);
    if (this.currentMessage()) {
      this.addCurrentMessageToMessageHistory();
    }
    this.currentMessage.set(message);
    if (!message.persist) {
      this.timeoutId = setTimeout(() => {
        this.addCurrentMessageToMessageHistory();
        this.currentMessage.set(null);
      }, MESSAGE_TIMEOUT * 1000);
    }
    setTimeout(() => {
      this.addedMessageToHistory.set(false);
    }, 1000);
  }

  showDetectionMessage(message: Message) {
    if (this.detectionMessage) {
      if (this.detectionMessage?.identifier !== message.identifier) {
        this.showMessage(message);
        this.detectionMessage = message;
        clearTimeout(this.timeoutDetection);
      } else if (this.killedDetectionMessage) {
        this.killedDetectionMessage = false;
        this.timeoutDetection = setTimeout(() => {
          this.killedDetectionMessage = true;
          this.detectionMessage = null;
        }, DETECTION_MESSAGE_TIMEOUT * 1000);
      }
    } else {
      this.showMessage(message);
      this.detectionMessage = message;
      clearTimeout(this.timeoutDetection);
    }
  }

  addCurrentMessageToMessageHistory() {
    if (
      this.messages()[this.messages.length]?.identifier !==
      this.currentMessage()?.identifier
    ) {
      this.messages.set([this.currentMessage(), ...this.messages()]);
    }
    this.addedMessageToHistory.set(true);
  }

  showDebugMessage(message: string, time?: number) {
    this.debugMessage.set(message);
    if (time) {
      setTimeout(() => {
        this.debugMessage.set(null);
      }, time * 1000);
    }
  }

  showTrackingInfo(message: string, time: number) {
    this.trackingInfo.set(message);
    if (time) {
      setTimeout(() => {
        this.trackingInfo.set(null);
      }, time * 1000);
    }
  }

  killCurrentMessage() {
    this.currentMessage.set(null);
  }

  killDebugMessage() {
    this.debugMessage.set(null);
  }

  clearMessages() {
    this.currentMessage.set(null);
    this.messages.set([]);
  }
}
